export default __webpack_public_path__ + "static/media/brandfolder.0899bb97.svg";